import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const CompleteTodoEvent = declareEvent('complete-todo', {
  id: string(),
});
export type CompleteTodoEvent = TypeOfEvent<typeof CompleteTodoEvent>;
